// Input — 7shifts style: 12px radius (general), Divider Gray border, без shadow.
import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-10 w-full rounded-base border border-divider-gray bg-canvas-white px-4 py-2 text-sm text-ink-black',
        // План 110: на телефоне поле выше и с 16px шрифтом. Меньший размер
        // заставляет iOS зумить страницу при фокусе — экран прыгает, и вернуть
        // масштаб можно только вручную.
        'max-lg:h-11 max-lg:text-base',
        'placeholder:text-muted-foreground',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-0 focus-visible:border-primary',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        className,
      )}
      {...props}
    />
  ),
);

Input.displayName = 'Input';
